/**
 * Higher-order function that wraps a callback with a close action
 * Useful for menu items that need to close the menu after executing an action
 */
export const withClose = (onClose: () => void) => (callback: () => void) => (): void => {
  callback()
  onClose()
}
